import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { SERVER_PATH } from "../config/env";
import AppHeader from "../components/Header";
import Home from "../components";
import HerbalProduct from "../components/Products/Herbal";
import GardenProduct from "../components/Products/Garden";
import Spices from "../components/Products/Spices";
import FoodProduct from "../components/Products/Food";
import Cart from "../components/Cart";
import MobNavbar from "../components/NavBar/Mobile";
import Profile from "../components/Profile";
import Login from "../components/Login";
import ErrorPage from "../components/NotFound";
import UserContextProvider from "../context/userContext";
import { PrivateRouter } from "../components/Router/PrivateRouter";
import Product from "../components/Products";
import About from "../components/About";
import Footer from "../components/Footer";
import YogaProduct from "../components/Products/Yoga";
import { PrivacyPolicy } from "../components/Privacy Policy";
import { TermsConditions } from "../components/Terms Conditions";
import YogaProducts from "../components/Products/yogaProducts";
import Gallery from "../components/Gallery";
import Tracker from "../components/Tracker";
import UniqueProducts from "../components/UniqueProducts";
import OrderSuccess from "../components/OrderSuccess";

function App() {
  const basename = process.env.NODE_ENV === "development" ? "" : (process.env.PUBLIC_URL || "");
  const [pathMap, setPathMap] = useState({});

  useEffect(() => {
    axios
      .get(`${SERVER_PATH}get/navbar.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data && res.data.path_map) {
          setPathMap(res.data.path_map);
        }
      })
      .catch((err) => {});
  }, []);

  return (
    <>
      <BrowserRouter basename={basename}>
        <UserContextProvider>
          <AppHeader />
          <MobNavbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Home />} />
            {pathMap.home && pathMap.home !== "/" && (
              <Route path={pathMap.home} element={<Home />} />
            )}

            {/* About */}
            <Route path="/about" element={<About />} />
            {pathMap.about && pathMap.about !== "/about" && (
              <Route path={pathMap.about} element={<About />} />
            )}

            {/* Gallery */}
            <Route path="/gallery" element={<Gallery />} />
            {pathMap.gallery && pathMap.gallery !== "/gallery" && (
              <Route path={pathMap.gallery} element={<Gallery />} />
            )}

            {/* Tracker */}
            <Route path="/tracker" element={<Tracker />} />
            {pathMap.tracker && pathMap.tracker !== "/tracker" && (
              <Route path={pathMap.tracker} element={<Tracker />} />
            )}

            <Route path="/orderSuccess" element={<OrderSuccess />} />

            {/* Unique Products */}
            <Route path="/uniqueProducts" element={<UniqueProducts />} />
            {pathMap.unique && pathMap.unique !== "/uniqueProducts" && (
              <Route path={pathMap.unique} element={<UniqueProducts />} />
            )}

            <Route
              path="/cart"
              element={
                <PrivateRouter>
                  <Cart />
                </PrivateRouter>
              }
            />
            <Route
              path="/cart/:productId"
              element={
                <PrivateRouter>
                  <Cart />
                </PrivateRouter>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRouter>
                  <Profile />
                </PrivateRouter>
              }
            />
            <Route
              path="/profile/:productId"
              element={
                <PrivateRouter>
                  <Profile />
                </PrivateRouter>
              }
            />

            {/* Herbal Products */}
            <Route path="/herbalProduct" element={<HerbalProduct />} />
            <Route path="/herbal" element={<HerbalProduct />} />
            {pathMap.herbal && !["/herbalProduct", "/herbal"].includes(pathMap.herbal) && (
              <Route path={pathMap.herbal} element={<HerbalProduct />} />
            )}

            {/* Garden Products */}
            <Route path="/gardenProduct" element={<GardenProduct />} />
            {pathMap.garden_page && pathMap.garden_page !== "/gardenProduct" && (
              <Route path={pathMap.garden_page} element={<GardenProduct />} />
            )}

            {/* Yoga Product Page */}
            <Route path="/yogaProduct" element={<YogaProduct />} />
            {pathMap.yoga_page && pathMap.yoga_page !== "/yogaProduct" && (
              <Route path={pathMap.yoga_page} element={<YogaProduct />} />
            )}

            {/* Health And Wellness / Spices */}
            <Route path="/yoga" element={<Spices />} />
            <Route path="/health" element={<Spices />} />
            <Route path="/wellness" element={<Spices />} />
            {pathMap.wellness && !["/yoga", "/health", "/wellness"].includes(pathMap.wellness) && (
              <Route path={pathMap.wellness} element={<Spices />} />
            )}

            {/* Food Products */}
            <Route path="/foodProduct" element={<FoodProduct />} />
            {pathMap.food_page && pathMap.food_page !== "/foodProduct" && (
              <Route path={pathMap.food_page} element={<FoodProduct />} />
            )}

            {/* Product detail pages */}
            <Route path="/product/:productId" element={<Product />} />
            <Route path="/yoga/:productId" element={<YogaProducts />} />
            <Route path="/health/:productId" element={<YogaProducts />} />
            {pathMap.wellness && (
              <Route path={`${pathMap.wellness}/:productId`} element={<YogaProducts />} />
            )}

            {/* Policy & Terms */}
            <Route path="/policy" element={<PrivacyPolicy />} />
            {pathMap.policy && pathMap.policy !== "/policy" && (
              <Route path={pathMap.policy} element={<PrivacyPolicy />} />
            )}

            <Route path="/terms" element={<TermsConditions />} />
            {pathMap.terms && pathMap.terms !== "/terms" && (
              <Route path={pathMap.terms} element={<TermsConditions />} />
            )}

            <Route path="*" element={<ErrorPage />} />
          </Routes>
          <Footer />
        </UserContextProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
